import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { ReportProductDoContent } from "./ReportProductDoContent";
import { ReportProductDoInitProvider } from "contexts/reportProductDoPage/ReportProductDoInitContext";
var providers = [
    function(children) {
        return /*#__PURE__*/ _jsx(ReportProductDoInitProvider, {
            children: children
        });
    }
];
var PageProvider = function(param) {
    var children = param.children;
    return providers.reduceRight(function(acc, ProviderFn) {
        return ProviderFn(acc);
    }, children);
};
export default function ReportProductDo() {
    return /*#__PURE__*/ _jsx(PageProvider, {
        children: /*#__PURE__*/ _jsx(ReportProductDoContent, {})
    });
}
